import './FilterChip.css';

/**
 * #124 — Chip de filtro canônico (extraído do padrão-ouro do NCList).
 * Chip com ícone + <select> nativo embutido. Fica "ativo" (verde) quando
 * o valor difere do placeholder ('todos').
 * Props:
 *  - icon?: nome do Material Symbol
 *  - value, onChange(value)
 *  - options: [{ value, label }]
 *  - placeholder: rótulo da opção "todos" (ex: "Status")
 *  - active?: força estado ativo (default = value && value !== 'todos')
 */
export default function FilterChip({ icon, value, onChange, options = [], placeholder, active }) {
  const isActive = active !== undefined ? active : (value != null && value !== 'todos' && value !== '');
  return (
    <span className={`ui-chip${isActive ? ' ui-chip--active' : ''}`}>
      {icon && <span className="material-symbols-outlined ui-chip__icon">{icon}</span>}
      <select
        className="ui-chip__select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onClick={(e) => e.stopPropagation()}
      >
        {placeholder && <option value="todos">{placeholder}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </span>
  );
}
